import { render, staticRenderFns } from "./KoioteLabel.vue?vue&type=template&id=359ca0d0&lang=es"
import script from "./KoioteLabel.vue?vue&type=script&lang=js"
export * from "./KoioteLabel.vue?vue&type=script&lang=js"
import style0 from "./KoioteLabel.vue?vue&type=style&index=0&id=359ca0d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports